import { observable, action } from 'mobx';

export default class EditorStore {

    constructor(root) {
        this.root = root;
    }

}